import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CreditCardFormResponse } from "@tCentro/Services/CENCreditApplicationFormService";


import { Draft } from "immer";


interface CreditCardState {
    isLoading: boolean;
    creditCardData?: CreditCardFormResponse; // Store the Credit Data data when available
}

const initialState: CreditCardState = {
    isLoading: false,
    creditCardData: undefined,
};

export default createTypedReducerWithImmer(initialState, {


    "Custom/CreditCardData/BeginLoad": (draft: Draft<CreditCardState>) => {
        draft.isLoading = true;
        draft.creditCardData = undefined; // Reset the data while loading
    },

    
    "Custom/CreditCard/CompletedLoad": (
        draft: Draft<CreditCardState>,
        action: {
            result: CreditCardFormResponse; 
        },
    ) => {
        draft.isLoading = false;
        draft.creditCardData = action.result; 
    },

    
    "Custom/CreditCard/FailedLoad": (draft: Draft<CreditCardState>) => {
        draft.isLoading = false;
        draft.creditCardData = undefined; 
    },
});
